"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClientConfig = void 0;
/**
 * Create a client config object.  In order to get around the fact that typescript doesn't support partial generic
 * inference, there's an additional function call that needs to be made in order to set the config typing.
 *
 * e.g:
 * const config = createClientConfig<MyConfigType>()({
 *   myClient: {
 *     class: MyClient
 *     //... rest of the MyConfigType fields
 *   }
 * });
 */
exports.createClientConfig = function () { return function (arg) { return arg; }; };
//# sourceMappingURL=functions.js.map